export interface Founder {
  name: string
  role: string
  expertise: string
  photo: string
  /** CSS object-position for the circular crop. */
  photoPosition?: string
  /** Extra zoom applied inside the circular crop. */
  photoScale?: number
  experience: string[]
}

export const founders: Founder[] = [
  {
    name: 'Fadi Rayyan',
    role: 'Founder & CEO',
    expertise: 'Telecom · Mobility · AI Platforms · Operations',
    photo:
      'https://cdn.magicpatterns.com/uploads/wkjHa3ExEkx1qRaKjwNEto/CTO_Updated.png',
    photoPosition: '50% 8%',
    photoScale: 1.3,
    experience: [
      'CTO, EasyLease — ADX-listed mobility group',
      'Founder & MD, Pair2 — mobility technology, EasyLease subsidiary',
      'Led Sheel — EasyLease subsidiary — from concept to nationwide operations',
      'Co-Founder, Yallow',
      'Former Founder, Esal — Telecom VAS',
      'B.Sc. Computer Information Systems',
    ],
  },
  {
    name: 'Mohamed Eliwah',
    role: 'Co-Founder & Chief Technology Officer',
    expertise: 'Security · Platform Engineering · Telecom Technology',
    photo:
      'https://cdn.magicpatterns.com/uploads/rjZGSJEbYY5bKHXcuAYJBT/ChatGPT_Image_Jul_1,_2026,_12_14_47_PM.png',
    photoPosition: '50% 24%',
    experience: [
      'CTO, Yallow',
      'Former Co-Founder, Shieldify',
      'B.Sc. Computer Engineering',
    ],
  },
]

export const teamStatement =
  'Built across telecom, mobility, platforms and consumer applications — now brought together in VEXU.'

export const teamCapabilities =
  'AI & ML · Backend · Mobile · DevOps · Telecom · Product · Operations'

export const inHouseNote = 'Core platform built in-house'
